const FormField = ({
  label,
  error,
  required,
  helpText,
  children,
  className = ''
}) => (
  <div className={className}>
    <label className="block text-sm font-medium text-gray-700 mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {helpText && (
      <p className="text-xs text-gray-500 mb-2">{helpText}</p>
    )}
    {children}
    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  </div>
);

export default FormField;